import interop from 'PythonDir/util/proxy/interop.json';
export default interop;
